module.exports = __webpack_public_path__ + "f0617e6d1572194298e4bc6886677275.svg";